import React, { useEffect, useState } from 'react';
import { 
    Container, Box, Typography, Grid, Card, CardContent, CardMedia, 
    IconButton, TextField, InputAdornment 
} from '@mui/material';
import {
    Search as SearchIcon, Info as InfoIcon, Phone as PhoneIcon, Email as EmailIcon, AttachMoney as MoneyIcon,
    Description as DescriptionIcon, Balance as BalanceIcon, Gavel as GavelIcon, Handshake as HandshakeIcon,
    DirectionsCar as DirectionsCarIcon, People as PeopleIcon, LocalHospital as LocalHospitalIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import TitleSection from './utils/TittleTheme';

export default function Transparencia({ config }) {
    const [searchTerm, setSearchTerm] = useState('');

    // Pega os cards customizados com foto diretamente da config indicada
    // Verifica se possui os dados necessários (foto, nome/titulo e link)
    const customCardsRaw = config?.transparencia?.card || [];
    const customCards = Array.isArray(customCardsRaw)
        ? customCardsRaw.filter(item => item && item.nome && item.foto && item.link)
        : [];

    // Pega os itens personalizados antigos diretamente da prop config
    const customItemsRaw = config?.transparencia_outros || [];

    // Normaliza para o formato esperado (array de objetos com title, link, icon...)
    const customItems = Array.isArray(customItemsRaw)
        ? customItemsRaw.map(item => ({
            icon: <DescriptionIcon fontSize="large" />, 
            title: item.nome || 'Item sem nome',
            link: item.link || '#',
            itemType: "https://turmalina.tcepb.tc.br/documentation/OtherInformation",
        }))
        : [];

    const customSection = customItems.length > 0
        ? [{
            title: "Outros",
            description: "Documentos e informações adicionais",
            items: customItems,
        }]
        : [];

    const sections = [
        {
            title: "Canais de Atendimento",
            description: "Lei Nº 12.527 (Acesso a Informação) - Lei Nº 13.460 (Carta de Serviços)",
            items: [
                { icon: <InfoIcon fontSize="large" />, title: "e-SIC", link: "/e-sic", itemType: "https://turmalina.tcepb.tc.br/documentation/CommunicationChannel" },
                { icon: <PhoneIcon fontSize="large" />, title: "Ouvidoria", link: "/ouvidoria", itemType: "https://turmalina.tcepb.tc.br/documentation/CommunicationChannel" },
                { icon: <EmailIcon fontSize="large" />, title: "Carta de Serviços", link: "/carta-de-servico", itemType: "https://turmalina.tcepb.tc.br/documentation/ServiceLetter" },
            ],
        },
        {
            title: "Receitas e Despesas",
            description: "Lei Nº 12.527 (Acesso a Informação) - Lei Complementar Nº 131 (Transparência)",
            itemtype: "https://turmalina.tcepb.tc.br/documentation/BudgetRevenue",
            items: [
                {
                    icon: <MoneyIcon fontSize="large" />,
                    title: "Receita Orçamentária",
                    link: config.transparencia?.receitaOrcamentaria || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/BudgetRevenue"
                },
                {
                    icon: <MoneyIcon fontSize="large" />,
                    title: "Receita Extraorçamentária",
                    link: config.transparencia?.receitaExtraorcamentaria || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/ExtraBudgetRevenue"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Despesa Orçamentária",
                    link: config.transparencia?.despesaOrcamentaria || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/BudgetExpenditure"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Despesa Extraorçamentária",
                    link: config.transparencia?.despesaExtraorcamentaria || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/ExtraBudgetExpenditure"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Documento de Pagamento",
                    link: config.transparencia?.documentoPagamento || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/PaymentDocument"
                },
            ]
        },
        {
            title: "Atos, publicações, pessoal, compras e convênios",
            description: "Lei Nº 12.527 (Acesso a Informação)",
            itemType: "https://turmalina.tcepb.tc.br/documentation/PlanningInstrument",
            items: [
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Instrumentos de Planejamento",
                    link: config.transparencia?.instrumentosPlanejamento || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/PlanningInstrument"
                },
                {
                    icon: <BalanceIcon fontSize="large" />,
                    title: "Leis Municipais",
                    link: config.transparencia?.leisMunicipais || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/LegalInstrument"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Decretos",
                    link: config.transparencia?.decretos || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/LegalInstrument"
                },
                {
                    icon: <PeopleIcon fontSize="large" />,
                    title: "Subvenções Sociais",
                    link: config.transparencia?.subvencaoSocial || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Subsidies"
                },
                {
                    icon: <PeopleIcon fontSize="large" />,
                    title: "Emendas Impositivas",
                    link: config.transparencia?.emendasImpositivas || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/ImpositiveAmendments"
                },
                {
                    icon: <PeopleIcon fontSize="large" />,
                    title: "Pessoal",
                    link: config.transparencia?.pessoal || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/EmployeeInformation"
                },
                {
                    icon: <GavelIcon fontSize="large" />,
                    title: "Licitações",
                    link: config.transparencia?.licitacoes || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Bidding"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Publicações",
                    link: config.transparencia?.publicacoes || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Publications"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Contratos licitatórios",
                    link: config.transparencia?.contratosLicitatorios || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Contract"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Contratos",
                    link: config.transparencia?.contratos || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Contract"
                },
                {
                    icon: <HandshakeIcon fontSize="large" />,
                    title: "Convênios Federal",
                    link: config.transparencia?.conveniosFederal || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Agreement"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Recursos Federais",
                    link: config.transparencia?.recursosFederais || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/FederalResources"
                },
                {
                    icon: <PeopleIcon fontSize="large" />,
                    title: "Estagiários",
                    link: config.transparencia?.estagiarios || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/Interns"
                },
                {
                    icon: <LocalHospitalIcon fontSize="large" />,
                    title: "COVID-19",
                    link: config.transparencia?.covid19 || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/EmergencyExpenditure"
                },
                {
                    icon: <DirectionsCarIcon fontSize="large" />,
                    title: "Frota Municipal",
                    link: config.transparencia?.frotaMunicipal || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/VehicleFleet"
                },
            ]
        },
        {
            title: "Regulamentações e Instrumentos de Pagamento",
            itemscope: 'itemscope',
            description: "Normas, Regulamentações, Pareceres, Planos e Informativos",
            itemType: "https://turmalina.tcepb.tc.br/documentation/PlanningInstrument",
            items: [
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "RREO",
                    link: config.transparencia?.rreo || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/BudgetReport"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "RGF",
                    link: config.transparencia?.rgf || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/FiscalResponsibilityReport"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "LOA",
                    link: config.transparencia?.loa || "#",
                    itemprop: "annualBudgetLaw",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/AnnualBudgetLaw"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "LDO",
                    link: config.transparencia?.ldo || "#",
                    itemprop: "budgetGuidelinesLaw",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/BudgetGuidelinesLaw"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "PPA",
                    link: config.transparencia?.ppa || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/MultiyearPlan",
                    itemprop: "multiyearPlan"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Regulamentação da LAI",
                    link: config.transparencia?.regulamentacaoLAI || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/LAIRegulation"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Regulamentação das Diárias",
                    link: config.transparencia?.regulamentacaoDiarias || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/TravelExpenseRegulation"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Renúncias Fiscais",
                    link: config.transparencia?.renunciasFiscais || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/TaxWaivers"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Informações de LGPD",
                    link: config.transparencia?.lgpd || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/LGPDInformation"
                },
                {
                    icon: <DescriptionIcon fontSize="large" />,
                    title: "Tabela de Valores das Diárias",
                    link: config.transparencia?.tabelaDiarias || "#",
                    itemType: "https://turmalina.tcepb.tc.br/documentation/TravelAllowanceTable"
                },
            ]
        },
        ...customSection
    ];

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value.toLowerCase());
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <TitleSection title={'PORTAL DA TRANSPARENCIA'} subtitle={'Acesso à Informação e Prestação de Contas com Clareza e Responsabilidade'} />

            <Box sx={{ mb: 3 }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Pesquisar por LOA, LDO, receitas, despesas..."
                    onChange={handleSearchChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>

            {/* Nova seção dinâmica baseada em config/transparencia/card */}
            {customCards.length > 0 && (
                <Box sx={{ mb: 5 }}>
                    <Typography variant="h5" component="div" gutterBottom>
                        Destaques da Transparência
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        Acesso rápido aos principais painéis informativos.
                    </Typography>

                    <Grid container spacing={3}>
                        {customCards
                            .filter((item) => item.nome.toLowerCase().includes(searchTerm))
                            .map((item) => (
                                <Grid item xs={12} sm={6} md={4} key={item.id || item.nome}>
                                    <Link style={{ textDecoration: 'none' }} to={item.link}>
                                        <Card
                                            variant="outlined"
                                            sx={{
                                                transition: '0.3s',
                                                '&:hover': {
                                                    boxShadow: 6,
                                                    transform: 'scale(1.02)',
                                                },
                                            }}
                                        >
                                            <CardMedia
                                                component="img"
                                                height="180"
                                                // width="100"
                                                image={item.foto}
                                                alt={item.nome}
                                                sx={{ objectFit: 'cover' }}
                                            />
                                            <CardContent>
                                                <Typography 
                                                    align="center" 
                                                    variant="subtitle1" 
                                                    sx={{ fontWeight: '500', color: 'text.primary' }}
                                                >
                                                    {item.nome}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Link>
                                </Grid>
                            ))}
                    </Grid>
                </Box>
            )}

            {/* Renderização das seções normais */}
            {sections.map((section, index) => (
                <Box key={index} sx={{ mb: 4 }} itemscope itemType={section?.itemType}>
                    <Typography variant="h5" component="div" gutterBottom>
                        {section.title}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        {section.description}
                    </Typography>

                    <Grid container spacing={3} itemscope itemType={section?.itemType}>
                        {section.items
                            .filter((item) => item.title.toLowerCase().includes(searchTerm))
                            .map((item, i) => (
                                <Grid item xs={12} sm={6} md={4} key={i} itemscope itemprop={item.itemprop} itemtype={item.itemType}>
                                    <Link style={{ textDecoration: 'none' }} to={item.link}>
                                        <Card
                                            variant="outlined"
                                            sx={{
                                                textDecoration: 'none',
                                                transition: '0.3s',
                                                '&:hover': {
                                                    boxShadow: 6,
                                                    transform: 'scale(1.02)',
                                                    textDecoration: 'none',
                                                },
                                            }}
                                        >
                                            <CardContent
                                                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textDecoration: 'none' }}
                                                itemscope
                                                itemprop={item.itemprop}
                                                itemtype={item.itemType}
                                            >
                                                <IconButton
                                                    itemscope
                                                    itemtype={item.itemType}
                                                    itemprop={item.itemprop}
                                                    component="a"
                                                    target="_blank"
                                                    color="primary"
                                                    size="large"
                                                    sx={{ mb: 1 }}
                                                >
                                                    {item.icon}
                                                </IconButton>
                                                <Typography itemprop={item.itemprop} itemtype={item.itemType} align="center" style={{ textDecoration: 'none', textDecorationColor: 'transparent' }} sx={{ fontSize: 19, textDecoration: 'none' }}>
                                                    {item.title}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Link>
                                </Grid>
                            ))}
                    </Grid>
                </Box>
            ))}
        </Container>
    );
}